import styled from 'styled-components'

export const SupportedFileTypesBannerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`
